import { useEffect } from 'react';
import { useRouter } from 'next/router';
import useUser from '../../lib/useUser';
import Loading from '../../components/common/Loading';
import InternalLayout from '../../components/layouts/internal/InternalLayout';
import * as onboardingWizard from '../../lib/onboardingWizard';

function Index() {
  const { user, workspace } = useUser({ redirectTo: '/login' });
  const router = useRouter();
  useEffect(() => {
    if(user && user.workspaces) {
      if(!onboardingWizard.isWorkspaceLoaded(workspace)) {
        return undefined;
      }
      const landing = onboardingWizard.shouldLandInWizard(user, workspace) ? 'get-started' : 'testimonials';
      return router.push(`/${workspace?.id}/${landing}`);
    }
    return router.push('/');
  }, [workspace]);
  return <Loading />;
}

Index.Layout = InternalLayout;
export default Index;
